export default __webpack_public_path__ + "static/media/gdp.43c5157c.svg";